module.exports = __webpack_public_path__ + "img/unduh_format_&_data.f088a187.svg";